import React from 'react'

import FiltersSearch from '../../../../../features/components/Filters/FiltersSearch'
import ExportProductsAsCsv from './ExportProductsAsCsv'
import MediaProductsFiltersDropdown from '../../../../../features/components/Filters/MediaProductsFiltersDropdown'

import { MediaProductsContext } from '../MediaProductsContext'

import { MEDIA_PRODUCTS_FILTERS_SEARCH } from '../index'

import useStyles from './styles'

const MediaProductsFiltersWrapper = () => {
  const classes = useStyles()

  return (
    <div className={classes.mediaProductsFiltersWrapper}>
      <ExportProductsAsCsv Context={MediaProductsContext} />
      <MediaProductsFiltersDropdown Context={MediaProductsContext} />
      <FiltersSearch searchId={MEDIA_PRODUCTS_FILTERS_SEARCH} />
    </div>
  )
}

export default MediaProductsFiltersWrapper
